import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { API_URL } from '../utils/Functions';

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(`${API_URL}/api/public/blogs`)
      .then(res => res.json())
      .then(data => {
        let blogsArray = [];
        if (Array.isArray(data)) {
          blogsArray = data;
        } else if (data && Array.isArray(data.data)) {
          blogsArray = data.data;
        } else if (data && data.data && Array.isArray(data.data.data)) {
          blogsArray = data.data.data;
        }
        setBlogs(blogsArray);
      })
      .catch(err => console.error('Failed to load blogs:', err))
      .finally(() => setLoading(false));
  }, []);

  // Format date helper
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  return (
    <>
      <Navbar />
      
      <style>{`
        .blogs-hero {
          background: linear-gradient(135deg, rgba(6, 24, 48, 0.85) 0%, rgba(4, 15, 31, 0.95) 100%), url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80&w=2000') no-repeat center center;
          background-size: cover;
          padding: 100px 0 80px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        .blogs-hero::before {
          content: '';
          position: absolute;
          inset: 0;
          background: radial-gradient(circle at 50% 0%, rgba(207, 160, 71, 0.15) 0%, transparent 70%);
        }
        .blogs-hero-title {
          font-family: 'Inter', sans-serif;
          font-size: 42px;
          font-weight: 800;
          color: #ffffff;
          margin-bottom: 16px;
          position: relative;
          z-index: 1;
        }
        .blogs-hero-title span {
          color: #CFA047;
        }
        .blogs-hero-subtitle {
          font-size: 16px;
          color: rgba(255, 255, 255, 0.8);
          max-width: 600px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
          line-height: 1.6;
        }

        .blogs-section {
          padding: 80px 0;
          background: #f8fafc;
          min-height: 50vh;
        }

        .blogs-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(340px, 1fr));
          gap: 30px;
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }

        .blog-card {
          background: #ffffff;
          border-radius: 16px;
          overflow: hidden;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
          transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
          display: flex;
          flex-direction: column;
          height: 100%;
          border: 1px solid #eef1f5;
          text-decoration: none;
        }

        .blog-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 12px 30px rgba(0, 0, 0, 0.08);
          border-color: #dde3ea;
        }

        .blog-card-img-wrapper {
          position: relative;
          height: 220px;
          overflow: hidden;
        }

        .blog-card-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: transform 0.5s ease;
        }

        .blog-card:hover .blog-card-img {
          transform: scale(1.05);
        }

        .blog-card-badge {
          position: absolute;
          top: 16px;
          right: 16px;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(4px);
          color: #061830;
          font-size: 11px;
          font-weight: 700;
          padding: 6px 12px;
          border-radius: 20px;
          letter-spacing: 0.5px;
          text-transform: uppercase;
        }

        .blog-card-content {
          padding: 24px;
          display: flex;
          flex-direction: column;
          flex: 1;
        }

        .blog-card-meta {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 12px;
          font-size: 13px;
          color: #8496a9;
          font-weight: 500;
        }
        
        .blog-card-meta i {
          color: #CFA047;
          margin-right: 6px;
        }

        .blog-card-title {
          font-size: 19px;
          font-weight: 700;
          color: #061830;
          margin: 0 0 12px;
          line-height: 1.4;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .blog-card-excerpt {
          font-size: 14px;
          color: #4a5568;
          line-height: 1.6;
          margin-bottom: 24px;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
          flex: 1;
        }

        .blog-card-footer {
          margin-top: auto;
          padding-top: 16px;
          border-top: 1px solid #eef1f5;
        }

        .blog-card-btn {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: #CFA047;
          font-weight: 600;
          font-size: 14px;
          text-decoration: none;
          transition: gap 0.2s;
        }

        .blog-card:hover .blog-card-btn {
          color: #a67f35;
          gap: 12px;
        }

        .loading-state {
          text-align: center;
          padding: 100px 20px;
          color: #8496a9;
          font-size: 16px;
          font-weight: 500;
        }

        .loading-spinner {
          display: inline-block;
          width: 40px;
          height: 40px;
          border: 3px solid rgba(207, 160, 71, 0.3);
          border-radius: 50%;
          border-top-color: #CFA047;
          animation: spin 1s ease-in-out infinite;
          margin-bottom: 16px;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>

      <section className="blogs-hero">
        <div className="container">
          <h1 className="blogs-hero-title">Our Latest <span>Insights</span></h1>
          <p className="blogs-hero-subtitle">
            Stay updated with the latest news, articles, and expert opinions on taxation, corporate compliance, and business growth.
          </p>
        </div>
      </section>

      <section className="blogs-section">
        {loading ? (
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <div>Loading blogs...</div>
          </div>
        ) : blogs.length > 0 ? (
          <div className="blogs-grid">
            {blogs.map(blog => (
              <Link key={blog.id} to={`/blogs/${blog.slug || blog.id}`} className="blog-card">
                <div className="blog-card-img-wrapper">
                  <img 
                    src={blog.image || blog.img || 'https://images.unsplash.com/photo-1499750310107-5fef28a66643?auto=format&fit=crop&w=800&q=80'} 
                    alt={blog.title} 
                    className="blog-card-img"
                  />
                  <div className="blog-card-badge">Article</div>
                </div>
                <div className="blog-card-content">
                  <div className="blog-card-meta">
                    <span><i className="fa-regular fa-calendar"></i> {formatDate(blog.created_at)}</span>
                    {blog.views !== undefined && (
                      <span><i className="fa-regular fa-eye"></i> {Intl.NumberFormat('en-US', { notation: 'compact' }).format(blog.views)} Views</span>
                    )}
                  </div>
                  <h3 className="blog-card-title">{blog.title}</h3>
                  <div className="blog-card-excerpt">
                    {/* Stripping simple HTML tags for the excerpt if it contains any, or just rendering text */}
                    {blog.content ? blog.content.replace(/<[^>]+>/g, '').substring(0, 150) + '...' : ''}
                  </div>
                  <div className="blog-card-footer">
                    <span className="blog-card-btn">
                      Know more <i className="fa-solid fa-arrow-right"></i>
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '60px 20px', color: '#64748b' }}>
            <i className="fa-solid fa-folder-open" style={{ fontSize: '48px', color: '#cbd5e1', marginBottom: '16px' }}></i>
            <h3 style={{ fontSize: '20px', color: '#0f172a', margin: '0 0 8px' }}>No blogs found</h3>
            <p style={{ margin: 0 }}>Check back later for new updates and insights.</p>
          </div>
        )}
      </section>

      <Footer />
    </>
  );
};

export default Blogs;
